import { SHOW_LINKED_ACCOUNT_TOOLTIP } from "../Actions/types";

const INITIAL_STATE = {
  showLinkedAccountTooltip: false,
};

let calendarReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SHOW_LINKED_ACCOUNT_TOOLTIP:
      return { ...state, showLinkedAccountTooltip: action.payload };
    default:
      return state;
  }
};

export default calendarReducer;
